import TYPES from '../../types';

// Domain
import { MaritalStatusEntity } from '../../domain/entities/marital-status-entity';
import { MaritalStatusRepository } from '../../domain/repository/marital-status-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchMaritalStatusesQuery extends Query<Promise<Array<MaritalStatusEntity>>> {
  @Inject(TYPES.CATALOG_KUSPIT_MARITAL_STATUS_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_KUSPIT_MARITAL_STATUS_REPOSITORY)
  private readonly repository!: MaritalStatusRepository;

  internalExecute(): Promise<Array<MaritalStatusEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
